import { useState, useEffect, useRef } from 'react';

const galleryItems = [
  {
    src: 'https://storage.readdy-site.link/project_files/06aadc1d-6920-43e8-b307-dffb1d65b532/e07b2a9e-e5ad-4c9f-af31-a458e6132267_WhatsApp-Image-2026-06-09-at-12.52.30.jpeg?v=e6888a199ef2ca59b7e12e12e45acd53',
    label: 'Panel LED P5 HD - Trasera',
    span: 'col-span-2',
  },
  {
    src: 'https://storage.readdy-site.link/project_files/06aadc1d-6920-43e8-b307-dffb1d65b532/edbfbc30-2d9b-49c1-b4ba-2aea2fc11b5d_WhatsApp-Image-2026-06-09-at-12.52.31.jpeg?v=f3a3b2bfa018500f34720d3f48619977',
    label: 'Mecanismo de Curvatura Ajustable',
    span: 'col-span-1',
  },
  {
    src: 'https://storage.readdy-site.link/project_files/06aadc1d-6920-43e8-b307-dffb1d65b532/03705b76-babe-4524-8d81-3e47574029e5_WhatsApp-Image-2026-06-09-at-12.52.32-1.jpeg?v=1a806b64fdcdf46cd0b7323f55b51df0',
    label: 'Equipo Profesional en Oficina',
    span: 'col-span-1',
  },
  {
    src: 'https://storage.readdy-site.link/project_files/06aadc1d-6920-43e8-b307-dffb1d65b532/ded562f8-bf1f-4860-a060-779174faa7d7_WhatsApp-Image-2026-06-09-at-12.52.32.jpeg?v=81e8027c2378feb05774551a507f5d6a',
    label: 'Sistema de Curva Preciso',
    span: 'col-span-2',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=3x2%20meter%20LED%20display%20screen%20at%20luxury%20product%20launch%20expo%20event%2C%20sleek%20large%20LED%20screen%20on%20stage%2C%20dark%20elegant%20venue%2C%20cyan%20blue%20spotlight%20lighting%2C%20modern%20brand%20presentation%2C%20premium%20event%20production%2C%20cinematic%20photography&width=600&height=700&seq=gal024&orientation=portrait',
    label: 'Lanzamiento de Producto',
    span: 'col-span-1',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=3x2%20meter%20LED%20display%20screen%20at%20industrial%20trade%20show%20expo%20booth%2C%20professional%20exhibition%20hall%2C%20cyan%20blue%20neon%20accent%20lighting%2C%20corporate%20AV%20setup%20with%20large%20LED%20screen%2C%20large%20format%203x2m%20LED%20display%2C%20premium%20event%2C%20cinematic%20wide%20shot&width=600&height=700&seq=gal025&orientation=portrait',
    label: 'Feria Industrial',
    span: 'col-span-1',
  },
];

const GallerySection = () => {
  const [lightbox, setLightbox] = useState<{ src: string; label: string } | null>(null);
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.querySelectorAll('.gal-reveal').forEach((el, i) => {
              setTimeout(() => {
                (el as HTMLElement).style.opacity = '1';
                (el as HTMLElement).style.transform = 'scale(1)';
              }, i * 100);
            });
          }
        });
      },
      { threshold: 0.1 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    const handleKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setLightbox(null);
    };
    window.addEventListener('keydown', handleKey);
    return () => window.removeEventListener('keydown', handleKey);
  }, []);

  return (
    <section id="gallery" className="relative bg-[#111111] py-24 md:py-32">
      <div ref={sectionRef} className="max-w-7xl mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 border border-cyan-500/40 bg-cyan-500/10 text-cyan-400 text-xs font-semibold uppercase tracking-widest px-4 py-2 rounded-full mb-5">
            Galería
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-4">
            Expos y eventos que{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-sky-500">
              hablan por sí solos
            </span>
          </h2>
          <p className="text-gray-400 text-base md:text-lg max-w-xl mx-auto">
            Cada expo es una obra de arte visual. Descubre algunos de nuestros trabajos más destacados en ferias y eventos.
          </p>
          <div className="w-20 h-1 bg-gradient-to-r from-cyan-400 to-sky-500 rounded-full mx-auto mt-6" />
        </div>

        {/* Masonry Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {galleryItems.map((item) => (
            <div
              key={item.src}
              className={`gal-reveal relative group rounded-2xl overflow-hidden cursor-pointer ${item.span}`}
              style={{ opacity: 0, transform: 'scale(0.95)', transition: 'opacity 0.6s ease, transform 0.6s ease' }}
              onClick={() => setLightbox({ src: item.src, label: item.label })}
            >
              <img
                src={item.src}
                alt={item.label}
                className="w-full h-56 md:h-64 object-cover object-top group-hover:scale-110 transition-transform duration-700 brightness-90 group-hover:brightness-100"
              />
              {/* Overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-400" />
              <div className="absolute bottom-0 left-0 right-0 p-5 translate-y-4 group-hover:translate-y-0 opacity-0 group-hover:opacity-100 transition-all duration-400">
                <span className="text-white font-semibold text-base">{item.label}</span>
              </div>
              {/* Zoom icon */}
              <div className="absolute top-4 right-4 w-9 h-9 flex items-center justify-center rounded-full bg-black/50 text-cyan-400 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <i className="ri-zoom-in-line text-lg" />
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Lightbox */}
      {lightbox && (
        <div
          className="fixed inset-0 z-50 bg-black/95 flex items-center justify-center p-4"
          onClick={() => setLightbox(null)}
        >
          <div
            className="relative max-w-4xl w-full"
            onClick={(e) => e.stopPropagation()}
          >
            <img
              src={lightbox.src}
              alt={lightbox.label}
              className="w-full rounded-2xl object-cover"
            />
            <div className="absolute bottom-4 left-4 text-white font-semibold text-lg bg-black/50 px-4 py-2 rounded-xl">
              {lightbox.label}
            </div>
            <button
              onClick={() => setLightbox(null)}
              className="absolute top-4 right-4 w-10 h-10 flex items-center justify-center rounded-full bg-black/60 text-cyan-400 hover:bg-cyan-500/20 transition-colors duration-300 cursor-pointer"
            >
              <i className="ri-close-line text-xl" />
            </button>
          </div>
        </div>
      )}
    </section>
  );
};

export default GallerySection;
